import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { LocalizedClerkProvider } from './components/auth/LocalizedClerkProvider'
import { CLERK_PUBLISHABLE_KEY } from './config/clerk'
import { initSentry } from './lib/sentry'
import { instalaRecargaPorPedacoVelho } from './lib/recarga-por-pedaco-velho'
import { initWebVitals } from './lib/web-vitals'
import { registrarServiceWorkerDeAviso } from './lib/os-notification/aviso-do-sistema'
import App from './App'
import './styles/index.css'

// Sentry must be initialised before anything else renders
initSentry()

// CRASH-1458 — pedaço apagado pelo deploy: recarrega uma vez, sem laço.
instalaRecargaPorPedacoVelho()

const root = document.getElementById('app')
if (!root) throw new Error('Root element #app not found')

// React 19 error hooks route all error categories to Sentry — but ONLY when a DSN
// is configured. Without a DSN, Sentry is a no-op, so building the error handlers
// at boot just widens the boot surface for no benefit. Gating them keeps behaviour
// identical when a DSN IS set and shrinks the critical boot path otherwise.
const sentryReactErrorHandler = import.meta.env.VITE_SENTRY_DSN
  ? Sentry.reactErrorHandler()
  : undefined

createRoot(root, {
  onUncaughtError: sentryReactErrorHandler,
  onCaughtError: sentryReactErrorHandler,
  onRecoverableError: sentryReactErrorHandler,
}).render(
  <StrictMode>
    <LocalizedClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <App />
    </LocalizedClerkProvider>
  </StrictMode>,
)

// Web Vitals RUM — called after render, never inside a component, returns void synchronously.
// All async work is handled internally via web-vitals callbacks.
initWebVitals()

// STO-354/STO-359 — registra o service worker de aviso do SISTEMA OPERACIONAL.
// SÓ registro: a permissão em si só pode ser pedida por gesto do usuário
// (ver SettingsModal), nunca aqui no boot.
void registrarServiceWorkerDeAviso()
